export const SET_ACTIVE_TRIGGERS_TABLE = 'SET_ACTIVE_TRIGGERS_TABLE';

export const setActiveTriggersTable = (triggersTable: any) => ({
  type: SET_ACTIVE_TRIGGERS_TABLE,
  activeTriggersTable: triggersTable,
});
